import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        console.log("Route changed:", pathname);  // Check if the route change is being detected
        window.scrollTo(0, 0); // Scroll to top
    }, [pathname]);

    return null;
}
